import type { ReactNode } from 'react';

export type AlertTone = 'success' | 'info' | 'warning' | 'danger';

const TONES: Record<AlertTone, string> = {
  success: 'border-alert-success-line bg-alert-success-bg text-alert-success-fg',
  info: 'border-alert-info-line bg-alert-info-bg text-alert-info-fg',
  warning: 'border-alert-warning-line bg-alert-warning-bg text-alert-warning-fg',
  danger: 'border-alert-danger-line bg-alert-danger-bg text-alert-danger-fg',
};

/**
 * The legacy `.alert-*` box. `danger` is announced at once (`role="alert"`), the others politely.
 */
export function Alert({
  tone,
  className = '',
  children,
}: {
  /** `error` is an alias of `danger`, kept for the pre-login pages. */
  tone: AlertTone | 'error';
  className?: string;
  children: ReactNode;
}) {
  const resolved: AlertTone = tone === 'error' ? 'danger' : tone;
  return (
    <div
      role={resolved === 'danger' ? 'alert' : 'status'}
      className={`mb-4 rounded-bs border px-5 py-3 text-left ${TONES[resolved]} ${className}`}
    >
      {children}
    </div>
  );
}
